import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import _ from 'lodash'

import request from '~/apis/request'
import { loadingStates } from '~/config/constant'
import { convertDataDetail, getDefaultFoodOptionTypes } from '~/utils/foodDetail'

const initialState = {
  openPopUp: false,
  // Dữ liệu ban đầu được sử dụng để render ra UI
  data: {
    id: -1,
    quantity: 1,
    name: '',
    price: 0,
    original_price: 0,
    discount_amount: 0,
    description: '',
    stock_quantity: null,
    max_quantity_per_order: 0,
    vat_rate: 0,
    images: [
      {
        id: null,
        url: 'https://picsum.photos/1000', // image placeholder
      },
    ],
    is_using_video_menu: false, // biến để kiểm tra có setting video menu hay không
    thumbnail_url: '', // ảnh thumbnail video menu
    video_menu_url: '', // đường dẫn video menu
    food_option_types: [
      {
        id: 1,
        required: true,
        min: null,
        max: null,
        name: '',
        auto_add: false,
        selected_default: false,
        food_options: [
          {
            id: -1,
            name: '',
            description: '',
            min: null,
            max: null,
            price: 0,
            food_item_option_id: -1,
            // Xong nhớ comment vào nha
            // related_food_options: [
            //   {
            //     food_option_type_id: -1,
            //     food_option_type_name: '',
            //      selected_default: null,
            //     food_options: [
            //       {
            //         id: 3984,
            //         price: 0,
            //         name: 'Set Pepsi',
            //         partner_id: '1762001000000',
            //         linkage_food_option_id: 17,
            //       },
            //     ],
            //   },
            // ],
          },
        ],
      },
    ],
    buffet_items: [], // trường hợp không có trả về mảng rỗng
    serving_time: null,
  },
  // Dữ liệu được chọn
  dataSelected: {
    id: -1,
    quantity: 1,
    name: '',
    price: 0,
    original_price: 0,
    discount_amount: 0,
    description: '',
    stock_quantity: null,
    max_quantity_per_order: 0,
    vat_rate: 0,
    images: [
      {
        id: null,
        url: 'https://picsum.photos/1000', // image placeholder
      },
    ],
    food_option_types: [
      {
        id: 1,
        required: true,
        min: null,
        max: null,
        name: '',
        auto_add: false,
        selected_default: false,
        food_options: [
          {
            id: -1,
            name: '',
            description: '',
            min: null,
            max: null,
            price: 0,
            food_item_option_id: -1,
          },
        ],
      },
    ],
    food_type: '',
  },

  loading: loadingStates.idle,
  error: {},
}

export const fetchItemDetail = createAsyncThunk(
  'itemDetail/fetchDetail',
  async ({ restaurantId, itemId, isBuffetItem }, { rejectWithValue }) => {
    try {
      const response = await request().get(`/restaurants/${restaurantId}/food_items/${itemId}`)
      return {
        ...response.data,
        isBuffetItem,
      }
    } catch (err) {
      const { status, data } = err.response
      return rejectWithValue({ status, data })
    }
  },
)

export const itemDetailSlice = createSlice({
  name: 'itemDetail',
  initialState,
  reducers: {
    setOpenPopUp: (state, action) => {
      state.openPopUp = action.payload
    },
    clearDataItemDetail: (state) => {
      state.data = {}
    },
    setFoodQuantity: (state, action) => {
      state.dataSelected.quantity = action.payload
    },
    changeToppingRadio: (state, action) => {
      const { foodOptionId, foodOptionTypeId } = action.payload
      // Data cũ ban đầu
      const oldFoodOptionType = state.data.food_option_types.find(
        (item) => item.id === foodOptionTypeId,
      )

      const foodOptionOld = oldFoodOptionType.food_options.find((item) => item.id === foodOptionId)
      foodOptionOld.quantity = foodOptionOld.min || 1 // bổ sung quantity phục vụ cho việc tính toán

      // Data mới được chọn
      const newFoodOptionType = state.dataSelected.food_option_types.find(
        (item) => item.id === foodOptionTypeId,
      )

      // Nếu trong trường hợp trước đó đã có data rồi -> chỉ cần replace
      if (newFoodOptionType) {
        // replace data khi người dùng thay đổi topping radio
        newFoodOptionType.food_options[0] = foodOptionOld
      } else {
        // Trường hợp chưa có food option type trong data selected -> sẽ phải push vào mảng data selected
        state.dataSelected.food_option_types.push({
          ...oldFoodOptionType,
          food_options: [foodOptionOld],
        })
      }

      // ------------------------- SUKIYA ------------------------------------

      // Index của food option type hiện tại
      const currentIndexFoodOptionType = state.data.food_option_types.findIndex(
        (item) => item.id === foodOptionTypeId,
      )

      if (currentIndexFoodOptionType >= 0) {
        // Index của food option type tiếp theo
        const nextIndexFoodOptionType = currentIndexFoodOptionType + 1
        // Lấy ra item tiếp theo của food option type
        const nextFoodOptionType = state.data.food_option_types[nextIndexFoodOptionType] // có thể undefined
        // Kiểm tra food option tiếp theo có liên quan gì đến food option type hiện tại hay không
        const isNextFoodOptionTypeRelatedPrevious =
          nextFoodOptionType &&
          nextFoodOptionType.food_option_type_id_related &&
          nextFoodOptionType.food_option_type_id_related === foodOptionTypeId

        /**
         * Nếu trong trường hợp có tồn tại related_food_options
         * 1. Chèn nó vào bên cạnh food option type hiện tại nếu trước đó chưa có
         * 2. Update giá trị tiếp theo bằng giá trị mới
         */
        if (foodOptionOld?.related_food_options) {
          // Lấy ra food option type mới để phục vụ cho việc chèn hoặc replace (update)
          const relatedFoodOptionType = foodOptionOld.related_food_options[0]
          // Lấy ra phần tử đầu tiên trong mảng food options mới này và bổ sung thêm trường quantity
          const firstFoodOptionRelated = relatedFoodOptionType.food_options[0]
          firstFoodOptionRelated.quantity = 1 // Bổ sung thêm quantity để gửi lên BE

          // 2. (Update giá trị tiếp theo bằng giá trị mới) Trong trường hợp giá trị food option type tiếp theo có liên quan đến giá hiện tại
          if (isNextFoodOptionTypeRelatedPrevious) {
            const nextFoodOptionTypeId = nextFoodOptionType.id // lấy ra id của food option type tiếp theo

            // 2.1  Update lại data selected. Tìm kiếm index của phần tử tiếp theo dựa vào id và update lại
            // Tìm ra index của food opion type tiếp theo bên trong data selected dựa và id
            const nextIndexFoodOptionTypeDataSelected =
              state.dataSelected.food_option_types.findIndex(
                (item) => item.id === nextFoodOptionTypeId,
              )

            // Nếu trong trường hợp tồn tại trước đó trong data selected
            // Thực hiện cập nhật data selected hoặc xoá
            if (nextIndexFoodOptionTypeDataSelected >= 0) {
              // Nếu có selected_default được set -> thực hiện replace
              if (nextFoodOptionType?.selected_default) {
                // Thực hiện replace
                state.dataSelected.food_option_types[
                  nextIndexFoodOptionTypeDataSelected
                ].food_options = [firstFoodOptionRelated] || []
              } else {
                // Nếu không có -> Thực hiện xoá
                state.dataSelected.food_option_types.splice(nextIndexFoodOptionTypeDataSelected, 1)
              }
            } else {
              // Nếu trong trường hợp giá trị tiếp theo chưa tồn tại và selected_default = true -> push vào mảng data selected
              if (nextFoodOptionType?.selected_default) {
                // Push vào trong mảng data selected
                state.dataSelected.food_option_types.push({
                  id: relatedFoodOptionType.food_option_type_id,
                  name: relatedFoodOptionType.food_option_type_name,
                  food_options: [firstFoodOptionRelated] || [],
                  food_option_id_related: foodOptionId, // Mục đích là để đánh dấu là nó được sinh ra từ food option nào
                  food_option_type_id_related: foodOptionTypeId, // Đánh dấu food option type mới này được tạo ra từ cái gì
                  required: true,
                  min: null,
                  max: null,
                  auto_add: false,
                  display_image: relatedFoodOptionType?.display_image || false, // Thêm trường display image
                  selected_default: relatedFoodOptionType?.selected_default, // bổ sung thêm trường này vào trong data selected
                })
              }
            }

            // 2.2 Update lại UI. Thực hiện replace giá trị food option type ngay sau nó bằng giá trị fooption type mới
            state.data.food_option_types[nextIndexFoodOptionType] = {
              id: relatedFoodOptionType.food_option_type_id,
              name: relatedFoodOptionType.food_option_type_name,
              food_options: relatedFoodOptionType.food_options || [],
              food_option_id_related: foodOptionId, // Mục đích là để đánh dấu là nó được sinh ra từ food option nào
              food_option_type_id_related: foodOptionTypeId, // Đánh dấu food option type mới này được tạo ra từ cái gì
              required: true,
              min: null,
              max: null,
              auto_add: false,
              display_image: relatedFoodOptionType?.display_image || false, // Thêm trường display image
              selected_default: relatedFoodOptionType?.selected_default,
            }
          } else {
            // 1. (Thêm mới) Chèn food option type mới vào ngay bên cạnh food option type hiện tại. Phục vụ update lại UI
            state.data.food_option_types.splice(nextIndexFoodOptionType, 0, {
              id: relatedFoodOptionType.food_option_type_id,
              name: relatedFoodOptionType.food_option_type_name,
              food_options: relatedFoodOptionType.food_options || [],
              food_option_id_related: foodOptionId, // Mục đích là để đánh dấu là nó được sinh ra từ food option nào
              food_option_type_id_related: foodOptionTypeId, // Đánh dấu food option type mới này được tạo ra từ cái gì
              required: true,
              min: null,
              max: null,
              auto_add: false,
              display_image: relatedFoodOptionType?.display_image || false, // Thêm trường display image
              selected_default: relatedFoodOptionType?.selected_default, // bổ sung thêm trường này vào trong data UI
            })

            // Nếu trong trường hợp có set selected_default thì mới push vào data selected
            if (relatedFoodOptionType?.selected_default) {
              // Push vào trong mảng data selected
              state.dataSelected.food_option_types.push({
                id: relatedFoodOptionType.food_option_type_id,
                name: relatedFoodOptionType.food_option_type_name,
                food_options: [firstFoodOptionRelated] || [],
                food_option_id_related: foodOptionId, // Mục đích là để đánh dấu là nó được sinh ra từ food option nào
                food_option_type_id_related: foodOptionTypeId, // Đánh dấu food option type mới này được tạo ra từ cái gì
                required: true,
                min: null,
                max: null,
                auto_add: false,
                display_image: relatedFoodOptionType?.display_image || false, // Thêm trường display image
                selected_default: relatedFoodOptionType?.selected_default, // bổ sung thêm trường này vào trong data selected
              })
            }
          }
        } else if (isNextFoodOptionTypeRelatedPrevious) {
          /**
           * 3. Trường hợp remove food option type tiếp theo nếu:
           * + Giá trị của food option type tiếp theo có liên quan đến giá trị food option type hiện tại
           * + Food option hiện tại không có trường related_food_options (nghĩa là BE không trả về)
           */

          // 3.1  Remove phần tử tiếp theo trên UI
          state.data.food_option_types.splice(nextIndexFoodOptionType, 1)

          // 3.2 Tìm kiếm và xoá trong data selected
          // Lấy ra id của food option type tiếp theo mà có liên quan
          const nextFoodOptionTypeId = nextFoodOptionType.id
          // Thực hiện tìm index trong mảng data selected
          const nextIndexFoodOptionTypeDataSelected =
            state.dataSelected.food_option_types.findIndex(
              (item) => item.id === nextFoodOptionTypeId,
            )

          // Remove trong data selected
          if (nextIndexFoodOptionTypeDataSelected >= 0) {
            state.dataSelected.food_option_types.splice(nextIndexFoodOptionTypeDataSelected, 1)
          }
        }
      }
    },
    changeToppingCheckbox: (state, action) => {
      const { foodOptionId, foodOptionTypeId, checked } = action.payload

      // Lấy ra food option type ban đầu
      const oldFoodOptionType = state.data.food_option_types.find(
        (item) => item.id === foodOptionTypeId,
      )

      // Danh sách food option type mới được chọn
      const newFoodOptionTypes = state.dataSelected.food_option_types

      // Tìm ra food option type mới
      const newFoodOptionType = newFoodOptionTypes.find((item) => item.id === foodOptionTypeId)

      /**
       * Trường hợp trong mảng còn 1 phần tử => remove luôn cả food option type đi (1)
       * Trong trường hợp đang check mà uncheck => remove data khỏi mảng (2)
       */
      if (checked) {
        if (newFoodOptionType.food_options.length <= 1) {
          // (1)
          state.dataSelected.food_option_types = newFoodOptionTypes.filter(
            (item) => item.id !== foodOptionTypeId,
          )
        } else {
          // (2)
          newFoodOptionType.food_options = newFoodOptionType.food_options.filter(
            (item) => item.id !== foodOptionId,
          )
        }
      } else {
        const foodOptionOld = oldFoodOptionType.food_options.find(
          (item) => item.id === foodOptionId,
        )
        foodOptionOld.quantity = foodOptionOld.min || 1

        /**
         * Trường hợp !checked => thêm vào mảng
         * Thêm vào mảng sẽ xảy ra 2 trường hợp:
         *  1. Trường hợp đã có  food option type => push vào mảng
         *  2. Trường hợp chưa có food option type  => bổ sung thêm food option type được chọn và thêm food option
         */
        if (newFoodOptionType) {
          // TH1:
          newFoodOptionType.food_options = [...newFoodOptionType.food_options, foodOptionOld] //  Xử lý push vào mảng mới được chọn
        } else {
          // TH2:
          const foodOptionTypeUpdate = _.cloneDeep(oldFoodOptionType)

          foodOptionTypeUpdate.food_options = [foodOptionOld] // thay thế thành mảng có 1 phần tử được thêm mới

          state.dataSelected.food_option_types = [...newFoodOptionTypes, foodOptionTypeUpdate]
        }
      }
    },
    setQuantityFoodOption: (state, action) => {
      // Hàm xử lý lưu lưu lại số lượng của food option
      const { foodOptionId, foodOptionTypeId, quantity } = action.payload

      const newFoodOptionTypes = state.dataSelected.food_option_types
      const newFoodOptionType = newFoodOptionTypes.find((item) => item.id === foodOptionTypeId)
      const newFoodOption = newFoodOptionType.food_options.find((item) => item.id === foodOptionId)

      newFoodOption.quantity = quantity
    },

    setNoteFoodRedux: (state, action) => {
      // Hàm xử lý lưu note cho món ăn
      state.dataSelected.note = action.payload
    },
  },
  extraReducers: {
    [fetchItemDetail.pending]: (state) => {
      state.loading = loadingStates.pending
      state.error = {}
    },
    [fetchItemDetail.fulfilled]: (state, action) => {
      state.loading = loadingStates.success
      const isBuffetItem = action.payload.isBuffetItem

      state.data = {
        ...action.payload.data,
        food_option_types: getDefaultFoodOptionTypes(action.payload.data.food_option_types),
      }
      state.dataSelected = convertDataDetail(action.payload.data, isBuffetItem) // lưu trữ giá trị được chọn mặc định ban đầu
      state.error = {}
    },
    [fetchItemDetail.rejected]: (state, action) => {
      state.loading = loadingStates.error
      state.error = action.payload
    },
  },
})

export const {
  setOpenPopUp,
  clearDataItemDetail,
  setFoodQuantity,
  setNoteFoodRedux,
  changeToppingCheckbox,
  changeToppingRadio,
  setQuantityFoodOption,
} = itemDetailSlice.actions

export const selectOpen = (state) => {
  return state.itemDetail.openPopUp
}

export const selectItemDetail = (state) => {
  return state.itemDetail
}

export const selectFoodItemError = (state) => {
  return state.itemDetail.error
}

// Toàn bộ 3 phần dưới (1.2.3) chỉ liên quan đến tính tổng giá tiền

/* 1.Tính tổng tiền food option = số lượng * đơn giá */
const totalFoodOptions = (food_options) => {
  if (!Array.isArray(food_options)) return 0

  return food_options.reduce((total, item) => {
    const { price, quantity } = item
    return total + (quantity || 1) * (price || 0)
  }, 0)
}

/* 2.Tính tổng tiền topping type = tổng tiền của từng food option */
const totalFoodOptionTypes = (food_option_types) => {
  if (!Array.isArray(food_option_types)) return 0

  return food_option_types.reduce((total, item) => {
    const { food_options } = item
    return total + totalFoodOptions(food_options)
  }, 0)
}

/* 3.Tính tổng tiền chi tiết món ăn = (giá gốc + tổng tiền topping type) * số lượng */
export const selectTotalMoneyDetailFood = (state) => {
  const { price, food_option_types, quantity } = state.itemDetail.dataSelected
  return (price + totalFoodOptionTypes(food_option_types)) * (quantity || 1)
}

// Toàn bộ 3 phần dưới (4.5.6) chỉ liên quan đến tính tổng số lượng topping

/* 4. Tính tổng tiền food option = số lượng*/
const totalQuantityFoodOptions = (food_options) => {
  if (!Array.isArray(food_options)) return 0

  return food_options.reduce((total, item) => {
    const { quantity } = item
    return total + (quantity || 1)
  }, 0)
}

/* 5.Tính tổng quantity topping trong topping type = tổng quantity của từng food option */
const totalQuantityFoodOptionTypes = (food_option_types) => {
  if (!Array.isArray(food_option_types)) return 0

  return food_option_types.reduce((total, item) => {
    const { food_options } = item
    return total + totalQuantityFoodOptions(food_options)
  }, 0)
}

/* 6.Tính tổng quantity topping chi tiết món ăn = ( tổng tiền topping trong topping type) */
export const totalQuantityTopping = (state) => {
  const { food_option_types } = state.itemDetail.dataSelected
  return totalQuantityFoodOptionTypes(food_option_types)
}

export const selectFoodOptionTypes = (state) => state.itemDetail.dataSelected.food_option_types

export default itemDetailSlice.reducer
